import { TiroDescendant } from "@/editor/Base/types";

export enum DragTypes {
  QUESTION_ANSWER = "QUESTION_ANSWER",
  QUESTION_GROUP = "QUESTION_GROUP",
}

export const DEFAULT_ANSWER: TiroDescendant[] = [{ children: [{ text: "" }] }];
